import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ResultWidgetComponent } from './result-widget.component'
import { SharedModule } from '../shared.module'

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ResultWidgetComponent],
  exports: [ResultWidgetComponent],
  providers: []
})
export class ResultWidgetModule {}
